<template>
    <div v-resize="onResize">
       

    
   <v-container fluid>
      <v-card>
            <v-layout class = "mr-5 mt-4">

       <h2 style="margin-left:15px; margin-top :20px;font-family:Verdana;font-size:16px"> <v-icon>mdi-car-multiple</v-icon> Cars List</h2>
        <v-spacer></v-spacer>
        <v-text-field label = "Search" v-model = "searchCar"></v-text-field>
        <v-spacer></v-spacer>

        <v-btn @click="openDialog()" rounded outlined style="margin-top :15px; margin-right :10px;font-family:Verdana"> 
                        <v-icon>mdi-car </v-icon>
                           Add New Car
                       </v-btn>
       
     </v-layout>
       
      <v-container fluid>

          
        <v-simple-table dense fixed-header :height="windowSize.y - 140 " style="margin-top :-10px" >
        <thead>
            <tr style = "color:black;font-family:Verdana">
                <th class="text-center" style = "color:black;font-family:Verdana" > Plate No. </th>
                <th class="text-center" style = "color:black;font-family:Verdana"> Day Code </th>
                <th class="text-center" style = "color:black;font-family:Verdana"> Status </th>
                <!-- <th class="text-center" style = "color:black;font-family:Verdana"> Permission No. </th> -->
                <th class="text-center" style = "color:black;font-family:Verdana"> Driver </th>
                <th class="text-center" style = "color:black;font-family:Verdana"> Car Type </th>
                <th class="text-center" style = "color:black;font-family:Verdana">Action</th>
            </tr>
            </thead>
            <tbody>
               <tr v-for="item in filterCarsList" :key="item.PlateNo">
                 <td class="text-center" style = "color:black;font-family:Verdana">{{item.PlateNo}}</td>
                  <td class="text-center" style = "color:black;font-family:Verdana">{{item.Day_Code}}</td>
                   <td class="text-center" style = "color:black;font-family:Verdana">{{item.Status}}</td>
                    <!-- <td class="text-center" style = "color:black;font-family:Verdana">{{item.PermissionNo}}</td> -->
                     <td class="text-center" style = "color:black;font-family:Verdana">{{item.Driver}}</td>
                     <td class="text-center" style = "color:black;font-family:Verdana">{{item.CarType}}</td>
                      <td class="text-center" style = "color:black;font-family:Verdana">
                        <v-btn  elevation="0" x-small fab @click="editRec(item)">
                        <v-icon color="grey darken-1">mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn  elevation="0" x-small fab @click="deleteRec(item,item.PlateNo)">
                        <v-icon color="grey darken-1">mdi-trash-can-outline</v-icon>
                    </v-btn>
                      </td>
               </tr>
            </tbody>
            </v-simple-table>
        
     </v-container>
     

     <v-dialog v-model = "dialog" persistent width="350px">
      <v-card>
          <v-toolbar dense color="#213c57" dark> <v-icon>mdi-car-info</v-icon>
           <span style = "font-family: Verdana;font-size:15px"> Car Information</span>
            <v-spacer></v-spacer>
             <v-btn icon @click = "closeDialog()"><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-layout row>
                <v-row>
                    <v-col>
                      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                   <v-text-field required v-model="toAdd.PlateNo" outlined label = "Plate Number" dense :rules="nameRules" oninput="this.value = this.value.toUpperCase()"></v-text-field>
                  </v-form>
             
                  <!-- <v-text-field outlined label = "Day Code" dense></v-text-field> -->
                    <v-select v-model="toAdd.Day_Code" :items = "Daycode" dense outlined label = "Day Code "></v-select>
               
                  <v-select v-model="toAdd.Status" :items = "statuslist" dense outlined label = "Status"></v-select>
               
                   
                 <!-- <v-text-field v-model="toAdd.PermissionNo" outlined label = "Permission" dense></v-text-field> -->
          <v-combobox clearable @change = "selectLicense(toAdd.Driver)" v-model="toAdd.Driver" :items = "driverlist" dense outlined label = "Driver"></v-combobox>
                   <!-- <v-select  @change = "selectLicense(toAdd.Driver)" v-model="toAdd.Driver" :items = "driverlist" dense outlined label = "Driver"></v-select> -->
                 
                   <v-text-field readonly v-model="toAdd.licenseNo" outlined label = "License" dense></v-text-field>
                    <v-select  v-model="toAdd.CarType" :items = "typelist" dense outlined label = "Type"></v-select>
                </v-col>
                </v-row>
              </v-layout>
            <v-layout>
            <v-spacer></v-spacer>

              <v-btn  :disabled="!valid" style = "margin-top:-25px" block @click = "addCarlist()" color="success"> {{btnName}} </v-btn>
            </v-layout>
            </v-container>
          </v-card-text>
      </v-card>
     </v-dialog>
     </v-card>
     </v-container>
    </div>
</template>

<script>

// import axios from 'axios'
import api from '../api.js'
import swal from 'sweetalert'
import _ from 'lodash'
export default {
    components:{
       
    },
    created(){
    this.loadcarlist()
    this.loaddriverlist()
    this.loadcartype()
    },
    data(){
        return{
          searchCar : '',
        dialog: false,
        Daycode: ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
        carList:[],
        toAdd:{},
        driverlist:[],
        statuslist:['Used','Unused'],
        typelist:[],
        licenselist:[],
        driversRecords : [],
        btnName: '',
        valid : false,
        lazy: false,
        nameRules: [
            v => !!v || 'Plate number is required'
          ],

        }
    },
    computed:{
       filterCarsList(){
        //  if(this.searchCar == null){
        //    this.searchCar = ''
        //  }
         return this.carList.filter( rec => {
            return rec.PlateNo.toLowerCase().includes(this.searchCar.toLowerCase()) || rec.Driver === this.searchCar
          })
       }
    },

    methods: {
      openDialog(){
         this.dialog = true
         this.btnName = 'Add'
       },
       closeDialog(){
         this.dialog = false
         this.toAdd = {}
       },
       addCarlist(){
     
          
           let url = `${this.api}addCars`
        api.post(url, this.toAdd).then (res =>{
          // this.employeedata = res.data
         console.log(res.data)
            if(this.btnName === 'Add'){
           swal( "New Car Added", " " , "success" , {
                timer: 1000,
                button:false
            })
         }else{
           swal( "Car details succesfully updated", " " , "success" , {
                timer: 1000,
                button:false
            })
         }

          this.loadcarlist()
          this.dialog = false
       } ) 
       },
       loadcarlist(){
          let url =  `${this.api}carlist`
         api.get(url).then( res =>{
        this.carList = res.data
      //  console.log(this.employeedata)
      }) 
       },
       loaddriverlist(){
         let url = `${this.api}driversList`
         api.get(url).then(res =>{
           this.driversRecords = res.data.filter( rec => {
              return rec.name
              
           })
           this.driverlist  = res.data.filter( rec => {
             return rec.available == 'Yes'
           }).map( rec1 => {
              return rec1.name
           }).sort()
         })
       },
       selectLicense(val){
          // console.log(val) 
           this.toAdd.licenseNo = this.driversRecords.filter( rec => {
              return rec.name == val
           }).map( rec1 => {
              return rec1.license_id
            })

           let index = this.toAdd.licenseNo.length - 1
            console.log(index)

            this.toAdd.licenseNo = this.toAdd.licenseNo[index]

          //  let index = this.toAdd.licenseNo[this.toAdd.licenseNo-1]
          //  console.log(index)
           console.log(this.toAdd.licenseNo)
       },

       loadcartype(){
         let url = `${this.api}cartypelist`
         api.get(url).then(res =>{
           this.typelist = _.orderBy(res.data, ['cartype'], ['ASC']).filter(r =>{
             return r.id !== '000001'
           }).map(rec => {
             return rec.cartype
           })
         })
       },

          editRec(rec){
           
          this.dialog = true
          this.btnName = 'Update'
          this.toAdd = rec
          // this.toAdd.PlateNo = rec.PlateNo
          // this.toAdd.Day_Code = rec.Day_Code
          // this.toAdd.Status = rec.Status
          // this.toAdd.PermissionNo = rec.PermissionNo  
          // this.toAdd.Driver = rec.Driver  
          // this.toAdd.licenseNo = rec.licenseNo  
          // this.toAdd.CarType = rec.CarType  
      },

      deleteRec(rec,PlateNo) {

          swal({
          title: 'Do you want to delete this car?',
          icon : 'warning',
          closeOnEsc: false,
          closeOnClickOutside: false,
          buttons : [ 'No',  'Yes']
            
          }).then( (willApprove)=>{
             if (willApprove) {
               swal( "Car deleted", " " , "error" , {
                timer: 1000,
                button:false
               })
            const index = this.carList.indexOf(rec) 
            this.carList.splice(index,1)
            let url = `${this.api}deleteCar`
            api.post(url,{PlateNo:PlateNo}).then( res => {
            console.log(res.data)
            
            this.loadcarlist()
            })
             }
          })

       
        
      },




    }
}


</script>

<style scoped>
table,th,td {
  border: 1px solid grey !important;
}
td{
  padding: 3px !important;
}

th{  
    background-color: #213c57 !important;
    color:white !important;
    font-family: Arial !important;
    padding:15px !important;
    font-size:13px;
}
tr:hover {
  background-color: #cdcdd1 !important;
}

</style>


